import { Row } from "antd";
import React from "react";

const TagInfo = () => {
  return (
    <Row align="middle" justify="center" style={{margin:'10px 0'}}>
      <div
        style={{
          color: "#842029",
          backgroundColor: "#F8D7DA",
          border: "1px solid #f5c2c7",
          padding: 16,
          borderRadius: "0.375rem",          
        }}
      >
        <h3 style={{ margin: 0, fontWeight:400 }}>
          Para emitir o certificado, o aluno deve atingir no mínimo 70% do
          progresso.
        </h3>
      </div>
    </Row>
  );
};

export default TagInfo;
